import gql from 'graphql-tag';

export default gql`
query getFA_GetDeletedOrderPositions($id: ID!){
    fakturaAssist{
    	getFA_GetDeletedOrderPositions(id: $id){
				id
				productTable{
					id
					productLink
					productLinkLookNr
					productLinkLookName
					quantity
					labelRecipeLink
					virtualPositionLink
					orderPositionID
					taxCode
					taxName
					price
					total
					discount
					discountSpec
					weight
					productNr
					productName
					addition
					fax
					email
					internet
					additive
					indTextProduction
					indTextDeliveryNote
				}
			}
 	}
}`;
